import { createSelector } from 'reselect';
import { AppState } from '../../store/rootReducer';

const getPrevPath = (state: AppState) => state.pathReducer.prevPathName;
export const getPrevPathSelector = createSelector(getPrevPath, name => name);
